export default __webpack_public_path__ + "static/kurorty-img-10-c6b0fd5c727b978f4dabebdb3d58fa41.png";